import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { SrdsClaimDetailView } from '../components/views/srdsDashboardView'

export default function SrdsClaim() {
    return (
        <div className="srdsClaim">
            <Sidebar />
            <MainView><SrdsClaimDetailView /></MainView>
        </div>
    )
}
